import { createSignal } from "solid-js";

// True once the app has rendered real content at least once this page load.
// Until then a loader is the cold boot, so it covers the viewport (continuing
// the splash); afterwards, in-app waits stay scoped to the content panel so a
// navigation doesn't black out the whole shell. Resets on a real page reload.
const [appBooted, setAppBooted] = createSignal(false);

export { appBooted };
export const markAppBooted = () => setAppBooted(true);
